// Fonction pour convertir une image en base64
export const imageToBase64 = (imgElement) => {
    return new Promise((resolve, reject) => {
        if (!imgElement) {
            resolve(null);
            return;
        }

        const img = new Image();
        img.crossOrigin = 'Anonymous';

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/png'));
        };

        img.onerror = reject;
        img.src = imgElement.src || imgElement;
    });
};


// Fonction pour convertir le composant footer en image
export const componentToBase64 = async (component) => {
    return new Promise(async (resolve) => {
        try {
            const html2canvas = (await import('html2canvas')).default;

            // Créer un conteneur temporaire
            const tempDiv = document.createElement('div');
            tempDiv.style.position = 'absolute';
            tempDiv.style.left = '-9999px';
            tempDiv.style.width = '1000px';
            tempDiv.style.background = 'white';
            document.body.appendChild(tempDiv);

            // Créer un root React pour le composant
            const { createRoot } = await import('react-dom/client');
            const root = createRoot(tempDiv);

            // Rendre le composant
            await new Promise((resolveRender) => {
                root.render(
                    <div style={{ width: '100%', padding: '10px' }}>
                        {component}
                    </div>
                );
                setTimeout(resolveRender, 100);
            });

            // Convertir en canvas
            const canvas = await html2canvas(tempDiv, {
                scale: 2,
                backgroundColor: '#ffffff',
                logging: false
            });

            const base64 = canvas.toDataURL('image/png');

            // Nettoyer
            root.unmount();
            document.body.removeChild(tempDiv);

            resolve(base64);
        } catch (error) {
            console.error('Erreur conversion footer:', error);
            resolve(null);
        }
    });
};
